import React from 'react';
import OpportunityDashboard from '../components/opportunities/OpportunityDashboard';

const Opportunities = () => {
  return <OpportunityDashboard />;
};

export default Opportunities;
